import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<Pick<ChallengeFormType, 'faq'>> = () => ({
  isValid: true,
});
